class SopapetsMaterialPicker extends HTMLElement {
  #controller;
  #imageTimer;
  #finishTimer;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();

    const signal = this.#controller.signal;
    this.addEventListener('click', this.#handleClick, { signal });
    this.addEventListener('pointerenter', this.#syncSwatching, { signal });
    this.addEventListener('pointerleave', this.#syncSwatching, { signal });
    this.addEventListener('focusin', this.#syncSwatching, { signal });
    this.addEventListener('focusout', this.#syncSwatching, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    window.clearTimeout(this.#imageTimer);
    window.clearTimeout(this.#finishTimer);
  }

  #handleClick = (event) => {
    const option = event.target.closest('[data-spv51-material-option]');
    if (!option) return;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile && !this.classList.contains('spv51-material-picker--expanded')) {
      this.classList.add('spv51-material-picker--expanded');
      return;
    }

    if (option.getAttribute('aria-pressed') === 'true') {
      this.classList.remove('spv51-material-picker--expanded');
      return;
    }

    const card = this.closest('.spv4-product-card');
    const primaryImage = card.querySelector('.spv4-product-card__image--primary');
    const secondaryImage = card.querySelector('.spv4-product-card__image--secondary');
    const materialName = this.querySelector('[data-spv51-material-name]');
    const status = this.querySelector('[data-spv51-material-status]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    for (const button of this.querySelectorAll('[data-spv51-material-option]')) {
      button.setAttribute('aria-pressed', String(button === option));
    }

    materialName.textContent = option.dataset.spv51MaterialNameValue;
    status.textContent = '';
    window.requestAnimationFrame(() => {
      status.textContent = option.dataset.spv51MaterialNameValue;
    });

    window.clearTimeout(this.#imageTimer);
    window.clearTimeout(this.#finishTimer);
    card.classList.add('spv51-product-card--swatching');

    const updateImages = () => {
      primaryImage.src = option.dataset.spv51PrimarySrc;
      primaryImage.srcset = option.dataset.spv51PrimarySrcset;
      primaryImage.alt = option.dataset.spv51PrimaryAlt;

      if (!secondaryImage) return;
      secondaryImage.src = option.dataset.spv51SecondarySrc;
      secondaryImage.srcset = option.dataset.spv51SecondarySrcset;
      secondaryImage.alt = option.dataset.spv51SecondaryAlt;
    };

    if (reduceMotion) {
      updateImages();
      this.classList.remove('spv51-material-picker--expanded');
      this.#syncSwatching();
      return;
    }

    card.classList.remove('spv51-product-card--switching');
    void card.offsetWidth;
    card.classList.add('spv51-product-card--switching');
    this.#imageTimer = window.setTimeout(updateImages, 245);
    this.#finishTimer = window.setTimeout(() => {
      card.classList.remove('spv51-product-card--switching');
      this.classList.remove('spv51-material-picker--expanded');
      this.#syncSwatching();
    }, 540);
  };

  #syncSwatching = () => {
    window.requestAnimationFrame(() => {
      const card = this.closest('.spv4-product-card');
      const isInteracting = this.matches(':hover') || Boolean(this.querySelector(':focus-visible'));
      card.classList.toggle('spv51-product-card--swatching', isInteracting);
    });
  };
}

if (!customElements.get('spv51-material-picker')) {
  customElements.define('spv51-material-picker', SopapetsMaterialPicker);
}
